export const setMenuActive = ({ commit }, data) => {
  commit('setMenuActive', data)
}
export const setCourseActive = ({ commit }, data) => {
  commit('setCourseActive', data)
}
export const setIndexActive = ({ commit }, data) => {
  commit('setIndexActive', data)
}
export const setCourse = ({ commit }, data) => {
  commit('setCourse', data)
}
export const setPartList = ({ commit }, data) => {
  commit('setPartList', data)
}
export const setGroup = ({ commit }, data) => {
  commit('setGroup', data)
}
export const setBread = ({ commit }, data) => {
  commit('setBread', data)
}
export const setDefinition = ({ commit }, data) => {
  commit('setDefinition', data)
}
export const setPlayAuth = ({ commit }, data) => {
  commit('setPlayAuth', data)
}
export const setSubCourse = ({ commit }, data) => {
  commit('setSubCourse', data)
}

export const setInfomationStatus = ({ commit }, data) => {
  commit('setInfomationStatus', data)
}